import FJLocalStore from '@src/store/FJLocalStore';
import styles from './FJCommon.module.less';

const FJErrorTitle = () => {
    return <p className={styles.required_error}>{FJLocalStore._('this field is required')}</p>;
};

export default FJErrorTitle;
